import React, { memo, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { lazyImport } from "../../utils/lazyImport";

import PrivateRouter, { PrivateRouteProps } from "../../Routes/RootNavigator/PrivateRouter";
import Spinner from "../../utils/Spinner";
import { PublicRouteProps } from "../../Routes/RootNavigator/PublicRouter";
import GenericTableList from "pages/GenericTable/GenericTableList";
import GenericTableDetails from "pages/GenericTable/GenericTableDetails";
import GenericTableCreate from "pages/GenericTable/GenericTableCreate";
import ToPayPickpAdd from "pages/ToPayPickup/ToPayPickup";
import AddBooking from "pages/Booking/AddBooking";
import BookingList from "pages/Booking/BookingList";
import UpdatePOD from "pages/POD/UpdatePOD";
import TrackingAWB from "pages/POD/TrackingAWB";
import AddMotherBag from "pages/MotherBag/AddMotherBag";
import MotherBagList from "pages/MotherBag/MotherBagList";
import ExpenseVouchureList from "pages/Vouchure/ExpenseVouchureList";
import RateCalculator from "pages/Rate/RateCalculator";
import MotherBagOutScan from "pages/MotherBag/MotherBagOutScan";
import MotherBagInScan from "pages/MotherBag/MotherBagInScan";
import ManageDRS from "pages/MotherBag/ManageDRS";
import GenerateAwb from "pages/AWB/GenerateAwb";
import DrsList from "pages/MotherBag/DrsList";
import BookingReport from "pages/Report/BookingReport";
import IntlRateCalculator from "pages/Rate/IntlRateCalculator";
import AddIntlBooking from "pages/Booking/AddIntlBooking";
import SendToThirdParty from "pages/MotherBag/SendToThirdParty";
import AttendanceReport from "pages/Report/AttendanceReport";
import Overedge from "pages/POD/Overedge";
import CashReport from "pages/Report/CashReport";
import VouchureGen from "pages/Billing/VouchureGen";
import CustomerBookReport from "pages/ReportCustomer/CustomerBookReport";
import CustomerTrackingAwb from "pages/POD/CustomerTrackingAwb";
import AdminDataChange from "pages/AdminDataChange";
import CreditReport from "pages/Report/CreditReport";
import InvoiceReport from "pages/Report/InvoiceReport";
import PublicSlip from "pages/AWB/PublicSlip";
import PrePickup from "pages/ToPayPickup/PrePickup";
import EmployeeDeliveryReport from "pages/Report/EmployeeDeliveryReport";
import VendorPayList from "pages/Vendor/VendorPayList";
import WalletList from "pages/Wallet/WalletList";
import FlightSearch from "pages/Report/FlightSearch";
import UserSecurity from "pages/Auth/UserSecurity";
import TrackingPickup from "pages/POD/TrackingPickup";
import GeoList from "pages/GeoTrack/GeoList";
import GeoLiveMap from "pages/GeoTrack/GeoLiveMap";
import GeoMapTimeline from "pages/GeoTrack/GeoMapTimeline";

//const { NotFound } = lazyImport(() => import("pages/NotFound"), "NotFound");

const { Dashboard } = lazyImport(() => import("pages/Dashboard"), "Dashboard");

const AppContent = () => {
  const GenericTables = [
    "branch",
    "subbranch",
    "customer",
    "agent",
    "user",
    "vendor",
    "rate",
    "country",
    "region",
    "state",
    "city",
    "product",
    "pincode",
    "tax",
    "rc_code",
    "international_zone",
    "international_rate",
  ];
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Spinner />
        </div>
      }
    >
      <Routes>
        <Route path="/dashboard">
          <Route index element={<PrivateRouter {...defaultPrivateRouteProps} outlet={<Dashboard />} />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" />} />

        <Route path="routing-rule">
          <Route
            // index
            path="list"
            element={<PrivateRouter {...defaultPrivateRouteProps} outlet={<Dashboard />} />}
          />
          {/* <Route path="add" element={<CreateAdmin />} /> */}
          <Route path="list/:id" element={<Dashboard />} />
          <Route path="add" element={<Dashboard />} />
        </Route>

        {GenericTables.map((tbl) => {
          return (
            <Route path={`/master/${tbl}`} key={"route-" + tbl}>
              <Route path="list" element={<PrivateRouter {...defaultPrivateRouteProps} outlet={<GenericTableList tableName={tbl} />} />} />
              {/* <Route path="add" element={<CreateAdmin />} /> */}
              <Route path="list/:id" element={<GenericTableDetails tableName={tbl} />} />
              <Route path="add" element={<GenericTableCreate tableName={tbl} />} />
            </Route>
          );
        })}

        <Route path="geo">
          <Route path="list" element={<GeoList />} />
          <Route path="live-map" element={<GeoLiveMap />} />
          <Route path="map-timeline" element={<GeoMapTimeline />} />
        </Route>

        <Route path="/topay-pickup">
          <Route
            // index
            path="list"
            element={<PrivateRouter {...defaultPrivateRouteProps} outlet={<Dashboard />} />}
          />
          {/* <Route path="add" element={<CreateAdmin />} /> */}
          <Route path="list/:id" element={<Dashboard />} />
          <Route path="add" element={<ToPayPickpAdd />} />
          <Route path="req" element={<PrePickup />} />
        </Route>
        <Route path="/booking">
          <Route
            // index
            path="list"
            element={<BookingList />}
          />
          {/* <Route path="add" element={<CreateAdmin />} /> */}
          <Route path="list/:id" element={<Dashboard />} />
          <Route path="add" element={<AddBooking />} />
          <Route path="add-intl" element={<AddIntlBooking />} />
        </Route>
        <Route path="/awb">
          <Route path="generate" element={<GenerateAwb />} />
          <Route path="open-slip" element={<PublicSlip />} />
        </Route>
        <Route path="/rate">
          <Route path="calculate" element={<RateCalculator />} />
          <Route path="intl-calculate" element={<IntlRateCalculator />} />
        </Route>
        <Route path="/mother_bag">
          <Route path="add" element={<AddMotherBag />} />
          <Route path="list" element={<MotherBagList />} />
          <Route path="outscan" element={<MotherBagOutScan />} />
          <Route path="inscan" element={<MotherBagInScan />} />
        </Route>
        <Route path="/drs">
          <Route path="manage" element={<ManageDRS />} />
          <Route path="list" element={<DrsList />} />
        </Route>
        <Route path="/third-party">
          <Route path="manage" element={<SendToThirdParty />} />
        </Route>
        <Route path="/pod">
          <Route path="update" element={<UpdatePOD />} />
          <Route path="tracking" element={<TrackingAWB />} />

          <Route path="overedge" element={<Overedge />} />
        </Route>
        <Route path="/pickup">
          <Route path="tracking" element={<TrackingPickup />} />
        </Route>
        <Route path="/vouchure">
          <Route
            // index
            path="expense/list"
            element={<ExpenseVouchureList />}
          />
        </Route>

        <Route path="/report">
          <Route path="booking" element={<BookingReport />} />
          <Route path="cash" element={<CashReport />} />
          <Route path="credit" element={<CreditReport />} />
          <Route path="invoice" element={<InvoiceReport />} />
          <Route path="attendance" element={<AttendanceReport />} />
          <Route path="emp-delivery" element={<EmployeeDeliveryReport />} />
          <Route path="flight" element={<FlightSearch />} />
        </Route>

        <Route path="/master/vendorpayment">
          <Route path="list" element={<VendorPayList />} />
          <Route path="add" element={<GenericTableCreate tableName={"vendorpayment"} />} />
          <Route path="list/:id" element={<GenericTableDetails tableName={"vendorpayment"} />} />
        </Route>

        <Route path="/master/wallet">
          <Route path="list" element={<WalletList />} />
        </Route>

        <Route path="/billing">
          <Route path="vouchure-gen" element={<VouchureGen />} />
        </Route>

        <Route path="/customer-report">
          <Route path="booking" element={<CustomerBookReport />} />
        </Route>
        <Route path="/customer-pod">
          <Route path="tracking" element={<CustomerTrackingAwb />} />
        </Route>

        <Route path="/admin">
          <Route path="data-change" element={<AdminDataChange />} />
        </Route>

        <Route path="/security/user">
          <Route path="list" element={<UserSecurity />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default memo(AppContent);

const defaultPublicRouteProps: Omit<PublicRouteProps, "outlet"> = {
  authenticatedPath: "/",
};

const defaultPrivateRouteProps: Omit<PrivateRouteProps, "outlet"> = {
  authenticationPath: "/login",
};
